import React, {useState, useEffect} from "react";
import {useParams} from 'react-router-dom';
import {SettlementDetailTypes, WithdrawalInfoTypes} from "../../../types/settlement/settlement.types";
import {getMemberWithdrawalDetail} from "../../../api/transaction/withdrawalApi";
import {formatDateTime, setComma} from "../../../utils/format";


export default function WithdrawalDetailPage() {

    const {id} = useParams<{ id: string }>();

    const [withdrawalInfoTypes, setWithdrawalData] = useState<WithdrawalInfoTypes>();

    const [loading, setLoading] = useState(true);


    const getWithdrawalDetail = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const result = await getMemberWithdrawalDetail(id);
            if (result.data.code === "00") {
                setWithdrawalData(result.data.data);
            }
        } catch (err) {
            console.error('출금 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getWithdrawalDetail();
    }, [])

    return (
        <>
            {(!loading && withdrawalInfoTypes) && (() => {

                const statusClass = withdrawalInfoTypes.status === "COMPLETED" ? "status finish" : "status cancel";
                const status = withdrawalInfoTypes.status === "COMPLETED" ? "출금 완료" : "출금 실패"

                return (
                    <main className="container type_gray no-bottom-nav">
                        <section className="bg-white">
                            <div className="inner-box">
                                <h3 className="dot-tit">기본 정보</h3>
                                <ul className="detail-info">
                                    <li><span className="tit">출금 요청 금액</span><span className="txt">{setComma(withdrawalInfoTypes.requestAmount)}원</span></li>
                                    <li><span className="tit">요청일시</span><span className="txt">{formatDateTime(withdrawalInfoTypes.regDate)}</span></li>
                                    <li><span className="tit">지급일시</span><span className="txt">{formatDateTime(withdrawalInfoTypes.regDate)}</span></li>
                                    <li><span className="tit">거래구분</span><span className="txt">출금</span></li>
                                    <li><span className="tit">출금번호</span><span className="txt">{withdrawalInfoTypes.withdrawalCode}</span></li>
                                    <li><span className="tit">정산상태</span><span className="txt"><span
                                        className={statusClass}>{status}</span></span></li>
                                </ul>
                            </div>
                        </section>
                        <section className="bg-white">
                            <div className="inner-box">
                                <h3 className="dot-tit">출금 정보</h3>
                                <ul className="detail-info">
                                    <li><span className="tit">출금 요청 금액</span><span className="txt">{setComma(withdrawalInfoTypes.requestAmount)}원</span></li>
                                    <li><span className="tit">출금 수수료</span><span className="txt">{setComma(withdrawalInfoTypes.withdrawalFee)}원</span></li>
                                    <li><span className="tit">은행명</span><span className="txt">{withdrawalInfoTypes.bankName}</span></li>
                                    <li><span className="tit">계좌번호</span><span className="txt">{withdrawalInfoTypes.bankAccount}</span></li>
                                </ul>
                            </div>
                        </section>
                        <section className="bg-white">
                            <div className="inner-box">
                                <h3 className="dot-tit">잔액 정보</h3>
                                <ul className="detail-info">
                                    <li><span className="tit">거래 전 잔액</span><span className="txt">{setComma(withdrawalInfoTypes.balanceBefore)}원</span></li>
                                    <li><span className="tit">거래 후 잔액</span><span className="txt">{setComma(withdrawalInfoTypes.balanceAfter)}원</span></li>
                                </ul>
                            </div>
                        </section>
                    </main>
                )
            }) ()}

        </>
    )
};